/**
 * session.storage.js
 * Single source of truth for reading/writing the auth token.
 * Relocated from components/ogm-auth/utils/tokenstore.js.
 *
 * IMPORTANT: the storage key ("ogm_token") is unchanged on purpose.
 * Anything outside this feature that reads localStorage directly under
 * that key (rather than importing tokenStore) keeps working even
 * before its import path is updated.
 */

import { AUTH_STORAGE_KEYS } from "../constants/authentication.constants";

export const sessionStorageService = {
    get: () => localStorage.getItem(AUTH_STORAGE_KEYS.TOKEN),
    set: (token) => localStorage.setItem(AUTH_STORAGE_KEYS.TOKEN, token),
    remove: () => localStorage.removeItem(AUTH_STORAGE_KEYS.TOKEN),
};

/**
 * Backward-compatible alias. Prefer `sessionStorageService` in new code;
 * this export exists so any external file still importing `tokenStore`
 * by name (from its old path) can be updated one at a time without a
 * flag-day rename. Check for imports of the old
 * "components/ogm-auth/utils/tokenstore" path before deleting the old file.
 */
export const tokenStore = sessionStorageService;
